/*
 * Copyright (c) 2026. Pacesetter
 * All Rights Reserved
 */

import * as types from './types';

export const fetchAccountingReportsRequest = () => ({
  type: types.FETCH_ACCOUNTING_REPORTS_REQUEST,
});

export const fetchAccountingReportsSuccess = data => ({
  type: types.FETCH_ACCOUNTING_REPORTS_SUCCESS,
  data,
});

export const fetchAccountingReportsFailure = error => ({
  type: types.FETCH_ACCOUNTING_REPORTS_FAILURE,
  error,
});

export const downloadAccountingReportRequest = () => ({
  type: types.DOWNLOAD_ACCOUNTING_REPORT_REQUEST,
});

export const downloadAccountingReportSuccess = data => ({
  type: types.DOWNLOAD_ACCOUNTING_REPORT_SUCCESS,
  data,
});

export const downloadAccountingReportFailure = error => ({
  type: types.DOWNLOAD_ACCOUNTING_REPORT_FAILURE,
  error,
});

export const manualTriggerAccountingRequest = () => ({
  type: types.MANUAL_TRIGGER_ACCOUNTING_REQUEST,
});

export const manualTriggerAccountingSuccess = data => ({
  type: types.MANUAL_TRIGGER_ACCOUNTING_SUCCESS,
  data,
});

export const manualTriggerAccountingFailure = error => ({
  type: types.MANUAL_TRIGGER_ACCOUNTING_FAILURE,
  error,
});

export const manualTriggerAccountingClear = () => ({
  type: types.MANUAL_TRIGGER_ACCOUNTING_CLEAR,
});

export const fetchFailReportSentConfigurationRequest = () => ({
  type: types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST,
});

export const fetchFailReportSentConfigurationRequestSuccess = data => ({
  type: types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS,
  data,
});

export const fetchFailReportSentConfigurationRequestFailure = error => ({
  type: types.FETCH_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE,
  error,
});

export const updateFailReportSentConfigurationRequest = () => ({
  type: types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST,
});

export const updateFailReportSentConfigurationRequestSuccess = data => ({
  type: types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_SUCCESS,
  data,
});

export const updateFailReportSentConfigurationFailure = error => ({
  type: types.UPDATE_FAIL_REPORT_SENT_CONFIGURATION_REQUEST_FAILURE,
  error,
});
